function frete_produto() {
    
    var postalCode = $('.product-shipping #billing_cep').val();
    var productId = $('form .product-variant-id').val(); // Pegando o valor da variante do formulário
    var quantity = $('.product-form__quantity .quantity__input').val(); // Defina a quantidade desejada
    
    console.log(`Quantidade: ${quantity}` ); 

    var originalCartItems = [];
    
    postalCode = postalCode.trim().replace('-', '');
    
    $('.product-shipping .results').hide();
    $('.product-shipping').addClass('waiting');
    
    if (postalCode === '') {
        //alert('Por favor, insira um CEP válido.');
        
        $('.product-shipping .results').hide();
        $('.product-shipping').removeClass('waiting');

        return;
    }

    // Consultar o ViaCEP para obter o estado
    $.ajax({
        url: `https://viacep.com.br/ws/${postalCode}/json/`,
        type: 'GET',
        dataType: 'json',
        success: function(data) {
            if (data.erro) {
                alert('CEP inválido. Por favor, tente novamente.');
                
                $('.product-shipping .results').hide();
                $('.product-shipping').removeClass('waiting');

                return;
            }

            var state = data.uf; // Obtém o estado a partir da resposta do ViaCEP

            // Primeiro, obter o conteúdo atual do carrinho
            $.ajax({
                url: '/cart.js',
                type: 'GET',
                dataType: 'json',
                success: function(cartData) {
                    originalCartItems = cartData.items; // Salvar os itens do carrinho original

                    // Limpar o carrinho
                    $.ajax({
                        url: '/cart/clear.js',
                        type: 'POST',
                        success: function() {
                            console.log('Carrinho limpo.');
                            //console.log(`Quantidade: ${quantity}`);

                            // Adicionar o produto para o cálculo do frete
                            $.ajax({
                                url: '/cart/add.js',
                                type: 'POST',
                                dataType: 'json',
                                data: {
                                    id: productId,
                                    quantity: quantity
                                },
                                success: function() {
                                    // Após adicionar ao carrinho, calcular o frete
                                    $.ajax({
                                        url: '/cart/shipping_rates.json',
                                        type: 'GET',
                                        data: {
                                            'shipping_address[zip]': postalCode,
                                            'shipping_address[country]': 'BR', // ou outro país
                                            'shipping_address[province]': state // Estado obtido via ViaCEP
                                        },
                                        success: function(data) {
                                            var rates = data.shipping_rates;
                                            var resultHtml = '';

                                            if (rates.length > 0) {

                                                $.each(rates, function(index, rate) {
                                                    resultHtml += '<p><span class="rate-name">' + rate.name + ':</span> R$ ' + rate.price + ' - <span class="rate-days">'+rate.delivery_days[0]+' dias úteis</span></p>';
                                                });
        
                                            } else {
                                                resultHtml = '<p>Não foi possível calcular o frete.</p>';
                                                $('.product-shipping').removeClass('waiting');
                                            }
        
                                            $('.product-shipping .results').html(resultHtml).slideDown();
                                            $('.product-shipping').removeClass('waiting');


                                            // Remover o produto de cálculo do frete
                                            $.ajax({
                                                url: '/cart/change.js',
                                                type: 'POST',
                                                dataType: 'json',
                                                data: {
                                                    id: productId,
                                                    quantity: 0
                                                },
                                                success: function() {
                                                    console.log('Produto removido do carrinho.');

                                                    // Restaurar os produtos originais no carrinho
                                                    if (originalCartItems.length > 0) {
                                                        originalCartItems.forEach(function(item) {
                                                            $.ajax({
                                                                url: '/cart/add.js',
                                                                type: 'POST',
                                                                dataType: 'json',
                                                                data: {
                                                                    id: item.id,
                                                                    quantity: item.quantity
                                                                },
                                                                success: function() {
                                                                    console.log('Produto restaurado: ' + item.title);
                                                                },
                                                                error: function() {
                                                                    console.log('Erro ao restaurar o produto: ' + item.title);
                                                                }
                                                            });
                                                        });
                                                    }
                                                },
                                                error: function() {
                                                    console.log('Erro ao remover o produto do carrinho.');
                                                }
                                            });
                                        },
                                        error: function() {
                                            alert('Erro ao calcular o frete. Por favor, tente novamente.');
                                        }
                                    });
                                },
                                error: function() {
                                    alert('Erro ao adicionar o produto ao carrinho. Por favor, tente novamente.');
                                }
                            });
                        },
                        error: function() {
                            console.log('Erro ao limpar o carrinho.');
                        }
                    });
                },
                error: function() {
                    console.log('Erro ao obter o conteúdo do carrinho.');
                }
            });
        },
        error: function() {
            alert('Erro ao consultar o CEP. Por favor, tente novamente.');
            $('.product-shipping .results').hide();
            $('.product-shipping').removeClass('waiting');
        }
    });
}